(function(){
  function p(n){return n<10?'0'+n:''+n}
  function day(d){return d.getFullYear()+'-'+p(d.getMonth()+1)+'-'+p(d.getDate())}
  function tick(){
    var now=Date.now();
    document.querySelectorAll('[data-tl-cd]').forEach(function(el){
      var end=new Date(el.getAttribute('data-end')).getTime();
      var left=Math.max(0,end-now),s=Math.floor(left/1000);
      var D=Math.floor(s/86400),H=Math.floor(s%86400/3600),M=Math.floor(s%3600/60),S=s%60;
      var L=(el.getAttribute('data-u')||'d,h,m,s').split(',');
      var h=(D?'<span><b>'+D+'</b>'+L[0]+'</span>':'')+'<span><b>'+p(H)+'</b>'+L[1]+'</span><span><b>'+p(M)+'</b>'+L[2]+'</span><span><b>'+p(S)+'</b>'+L[3]+'</span>';
      if(el.innerHTML!==h)el.innerHTML=h;
      if(!left){var box=el.closest('[data-tl-ends]');if(box)box.hidden=true;}
    });
  }
  function today(){
    var t=day(new Date()),hit=false;
    document.querySelectorAll('[data-tl-day]').forEach(function(r){var on=r.getAttribute('data-tl-day')===t;r.classList.toggle('is-now',on);if(on)hit=true;});
  }
  tick();today();setInterval(tick,1000);
})();
